import { useState, useEffect } from 'react';

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  containerClassName?: string;
}

export default function ImageWithFallback({
  src,
  alt,
  className = '',
  fallbackClassName = '',
  containerClassName = '',
}: ImageWithFallbackProps) {
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [src]);

  const fallback = (
    <div
      className={`flex items-center justify-center bg-background-100 text-foreground-400 ${fallbackClassName}`}
    >
      <div className="flex flex-col items-center gap-1">
        <div className="w-10 h-10 flex items-center justify-center">
          <i className="ri-image-line text-2xl" />
        </div>
        <span className="text-[10px] text-foreground-400">Image unavailable</span>
      </div>
    </div>
  );

  if (containerClassName) {
    return (
      <div className={containerClassName}>
        {error || !src ? fallback : (
          <img
            src={src}
            alt={alt}
            className={className}
            onError={() => setError(true)}
          />
        )}
      </div>
    );
  }

  if (error || !src) {
    return fallback;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setError(true)}
    />
  );
}